class StockFirstGrid extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.reorder().catch(() => {}).finally(() => this.removeAttribute('aria-busy'));
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  async reorder() {
    const grid = this.querySelector('ul.grid');
    if (!grid) return;
    const currentPage = Number(this.dataset.page);
    const totalPages = Number(this.dataset.pages);
    const pageSize = Number(this.dataset.pageSize);
    const rank = card => Number(card.dataset.stockRank ?? 1);
    const currentCards = Array.from(grid.children);
    if (totalPages <= 1) {
      grid.append(...currentCards.sort((left, right) => rank(left) - rank(right)));
      return;
    }
    this.setAttribute('aria-busy', 'true');
    const pages = new Map([[currentPage, currentCards]]);
    const pending = Array.from({ length: totalPages }, (_, index) => index + 1)
      .filter(page => page !== currentPage);
    const loadPage = async page => {
      const url = new URL(location.href);
      url.searchParams.set('section_id', this.dataset.section);
      url.searchParams.set(this.dataset.pageParam, String(page));
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) throw new Error('Unable to load product page');
      const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
      const remoteGrid = Array.from(documentPage.querySelectorAll('stock-first-grid'))
        .find(element => element.dataset.section === this.dataset.section)?.querySelector('ul.grid');
      if (!remoteGrid) throw new Error('Missing product grid');
      pages.set(page, Array.from(remoteGrid.children));
    };
    const workers = Array.from({ length: Math.min(3, pending.length) }, async () => {
      while (pending.length) await loadPage(pending.shift());
    });
    await Promise.all(workers);
    if (this.controller.signal.aborted || !this.isConnected) return;
    const cards = Array.from({ length: totalPages }, (_, index) => pages.get(index + 1)).flat();
    cards.sort((left, right) => rank(left) - rank(right));
    const offset = (currentPage - 1) * pageSize;
    grid.replaceChildren(...cards.slice(offset, offset + pageSize));
  }
}

if (!customElements.get('stock-first-grid')) {
  customElements.define('stock-first-grid', StockFirstGrid);
}
